// 防抖
export const debounce = (() => {
  let timer = null
  return (callback, wait) => {
    clearTimeout(timer)
    timer = setTimeout(callback, wait)
  }
})()

// 防抖
let syncDebounceTimer = null
let catchPromiseParma = null // promise一直没有返造成内存泄漏
export const syncDebounce = (awaitTime = 500) => {
  return new Promise((resolve, reject) => {
    clearTimeout(syncDebounceTimer)
    catchPromiseParma && catchPromiseParma.reject()
    catchPromiseParma = {
      resolve,
      reject
    }
    syncDebounceTimer = setTimeout(() => {
      resolve()
      catchPromiseParma = null
    }, awaitTime)
  })
}
